import "./App.scss";
import Header from "./components/Header/Header";
import HomePage from "./pages/HomePage/HomePage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import Nav from "./components/Nav/Nav";
import AddListingPage from "./pages/AddListingPage/AddListingPage";
import EditListingPage from "./pages/EditListingPage/EditListingPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import ReviewPage from "./pages/ReviewPage/ReviewPage";
import LoginPage from "./pages/LoginPage/LoginPage";
function App() {
  return (
    <Router>
      <Header />
      <Switch>
        <Route path="/" component={HomePage} exact />
        <Route path="/about" component={AboutUsPage} />
        <Route path="/:id/edit" component={EditListingPage} />
        <Route path="/add" component={AddListingPage} />
        <Route path="/:id/review" component={ReviewPage} />
        <Route path="/contact" component={ContactPage} />
        <Route path="/login" component={LoginPage} />
      </Switch>
      <div className="nav--mobile">
        <Nav />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
